import Vue from 'vue';
import { formatNumber, currencySymbol } from '../../filters/index.js';
import ButtonComponent from '../input/button.vue';
import CurrencyComponent from '../input/currency.vue';
import { months as availableMonths, idToMonth, idToMonthGenitive as genetiveMonth } from '../../datetime/month';
var countryCurrency = {
    RU: 'RUB',
    USA: 'USD'
};
var RangeMode;
(function (RangeMode) {
    RangeMode[RangeMode["LS"] = 0] = "LS";
    RangeMode[RangeMode["LSE"] = 1] = "LSE";
})(RangeMode || (RangeMode = {}));
;
function calcMultiplier(data, fromYear, fromMonth, toYear, toMonth, mode) {
    if (mode === void 0) { mode = RangeMode.LSE; }
    var entities = data.filter(function (i) {
        // toMonth less or equal, depending on Mode
        return ((i[0] > fromYear) ||
            (i[0] === fromYear && i[1] >= fromMonth)) &&
            ((i[0] < toYear) ||
                (mode === RangeMode.LS && (i[0] === toYear && i[1] < toMonth)) ||
                (mode === RangeMode.LSE && (i[0] === toYear && i[1] <= toMonth)));
    });
    var values = entities.map(function (i) { return Number(i[2]); });
    return values.reduce(function (x, y) { return x * (1 + y / 100); }, 1);
}
function isLse(y1, m1, y2, m2) {
    return (y1 < y2 || (y1 == y2 && m1 <= m2));
}
export default Vue.extend({
    props: [
        'inflData'
    ],
    data: function () {
        return {
            country: 'RU',
            availableMonths: availableMonths,
            value: 1000,
            inYear: 2016,
            inMonth: 1,
            outYear: 2018,
            outMonth: 1,
            result: 0,
            inflation: 0,
            notification: '',
            idToMonth: idToMonth,
            inDateGenetive: '',
            outDateGenetive: ''
        };
    },
    computed: {
        availableYears: function () {
            var minData = this.countryData[0][0], maxData = this.countryData[this.countryData.length - 1][0], res = [];
            for (var i = minData; i <= maxData; i++) {
                res.push(i);
            }
            return res;
        },
        currency: function () {
            return countryCurrency[this.country];
        },
        countryData: function () {
            return this.inflData[this.country];
        },
        currencySymbol: function () {
            return currencySymbol[this.currency] || '';
        },
        calculationMode: function () {
            if (this.inYear && this.inMonth && this.outYear && this.outMonth) {
                if (isLse(this.inYear, this.inMonth, this.outYear, this.outMonth)) {
                    return 'LESS';
                }
                return 'MORE';
            }
            return '';
        },
        availableRange: function () {
            var minData = this.countryData[0], maxData = this.countryData[this.countryData.length - 1];
            var _a = [minData[0], minData[1]], y1 = _a[0], m1 = _a[1];
            var _b = [maxData[0], maxData[1]], y2 = _b[0], m2 = _b[1];
            return [y1, m1, y2, m2];
        },
        availableRangeRepr: function () {
            var _a = this.availableRange, y1 = _a[0], m1 = _a[1], y2 = _a[2], m2 = _a[3];
            return idToMonth[m1] + " " + y1 + " \u2013 " + idToMonth[m2] + " " + y2;
        }
    },
    components: {
        'c-button': ButtonComponent,
        'currency-input': CurrencyComponent
    },
    methods: {
        buttonClicked: function () {
            this.notification = '';
            this.result = 0;
            this.inflation = 0;
            var multiplier = 1;
            if (!this.inYear || !this.inMonth || !this.outYear || !this.outMonth) {
                this.notification = 'Не все даты выбраны';
                return;
            }
            var _a = [this.inYear, this.inMonth,
                this.outYear, this.outMonth], y1 = _a[0], m1 = _a[1], y2 = _a[2], m2 = _a[3];
            if (this.calculationMode === 'LESS') {
                var error = this.isOutsideRange(y2, m2);
                if (error) {
                    this.notification = error;
                    return;
                }
                multiplier = calcMultiplier(this.countryData, y1, m1, y2, m2, RangeMode.LSE);
                this.inflation = (multiplier - 1) * 100;
                this.result = this.value * multiplier;
            }
            else if (this.calculationMode === 'MORE') {
                var error = this.isOutsideRange(y1, m1);
                if (error) {
                    this.notification = error;
                    return;
                }
                multiplier = calcMultiplier(this.countryData, y2, m2, y1, m1, RangeMode.LS);
                this.inflation = (multiplier - 1) * 100;
                this.result = this.value / multiplier;
            }
            this.inDateGenetive = genetiveMonth[m1] + " " + y1 + " \u0433.";
            this.outDateGenetive = genetiveMonth[m2] + " " + y2 + " \u0433.";
        },
        isOutsideRange: function (y, m) {
            var _a = this.availableRange, y1 = _a[0], m1 = _a[1], maxYear = _a[2], maxMonth = _a[3];
            if (m > maxMonth && y >= maxYear) {
                return 'Данных на выбранную дату нет. Проверьте допустимый диапазон.';
            }
            return '';
        }
    },
    filters: {
        number: formatNumber
    }
});
